import DatePickerGroup from './main.vue'

/* istanbul ignore next */
DatePickerGroup.install = function(Vue) {
  Vue.component(DatePickerGroup.name, DatePickerGroup)
}

export default DatePickerGroup
